<template>
    <div class="page-list">
        <v-page-header
            title="权限角色"
        />
        <v-status-bar
            v-if="!isSuperAdmin && !hasCloseTipFlagExist && !tipBarClosed && powerModelBak === 'self'"
            kind="alarm"
        >
            <div
                slot="default"
                class="status-bar-content"
            >
                <span class="content-text">因权限受限，你仅可编辑自己权限范围内的角色</span>
                <span
                    class="close-notice-btn"
                    @click="handleCloseNotice"
                >不再提醒</span>
            </div>
        </v-status-bar>
        <div v-spinner="loading">
            <v-spinner
                :opacity="0.5"
                :offset-y="150"
                size="large"
            />
            <div
                v-if="isShow == 1"
                id="setMeal-role-tip"
            >
                <div class="remind-info remind-info-wait">
                    <i class="icon-remind-warn" />
                    <span class="setMeal-title">
                        <span
                            v-for="(item, roleIndex) in expiredCombosList"
                            :key="roleIndex"
                        >
                            {{ item.name }}<i class="setMeal-symbol">、</i>
                        </span>
                        已到期，暂不可修改权限角色，续费或更新权限角色后可正常使用。
                    </span>
                    <span class="setMeal-text">
                        <a
                            href="javascript:;"
                            class="setMeal-renewal"
                            @click="roleRenew"
                        >
                            <span>续费</span>
                        </a>
                        <a
                            href="javascript:;"
                            class="setMeal-permissions"
                            @click="roleUpdate"
                        >
                            <span>更新所有权限角色</span>
                        </a>
                    </span>
                </div>
            </div>

            <div :class="[isShow == 1 ? 'disabled' : '']">
                <div class="role-list-head">
                    <v-button icon="basic_new_line" size="large" @click="createRole">
                        添加角色
                    </v-button>
                    <div
                        v-if="isAdmin"
                        class="power-manage"
                    >
                        <p class="desc">
                            员工可以给自己和其他人赋予权限的范围：{{
                                powerModelBak === 'all' ? '企业所有权限' : '仅本人拥有的权限'
                            }}
                        </p>
                        <div class="change-power">
                            <div
                                class="change-power-btn"
                                @click="handleChangePowerMode"
                            >
                                变更
                            </div>
                            <div
                                v-show="changePowerMenuVisiable"
                                class="panel-wrapper"
                            >
                                <div class="panel-body">
                                    <v-radio-group
                                        v-model="powerMode"
                                        vertical
                                    >
                                        <div
                                            v-for="(item, index) of options"
                                            :key="index"
                                            class="panel-body-item"
                                        >
                                            <v-radio
                                                :value="item.value"
                                                name="radio"
                                            >
                                                <span class="radio-label">
                                                    {{ item.label }}
                                                </span>
                                            </v-radio>
                                            <p
                                                class="desc"
                                                v-html="item.desc"
                                            />
                                            <p class="tip">
                                                {{ item.tip }}
                                            </p>
                                        </div>
                                    </v-radio-group>
                                </div>
                                <div class="panel-foot">
                                    <v-button
                                        status="primary"
                                        @click="handleConfirm"
                                    >
                                        确定
                                    </v-button>
                                    <v-button
                                        status="default"
                                        style="margin-left:10px;"
                                        @click="handleCancel"
                                    >
                                        取消
                                    </v-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    :key="listKey"
                    class="role-list"
                >
                    <template v-if="!roleList.length">
                        <div
                            v-show="!loading"
                            class="role-list-empty"
                        >
                            <div class="role-list-empty-icon" />
                            暂无角色
                        </div>
                    </template>
                    <template v-else>
                        <roleItem
                            v-for="item in roleList"
                            :key="'act_' + item.roleId"
                            :ori-data="item"
                            :userinfo="userinfo"
                            @copyRoleSucc="refreshList"
                            @delRoleSucc="refreshList"
                            @refreshRoleList="refreshList"
                        />
                    </template>
                </div>
                <div
                    v-if="total > 0"
                    class="role-list-pagination"
                >
                    <v-pagination
                        :index="index"
                        :total="total"
                        :count="count"
                        :count-options="countOptions"
                        @change="changePage"
                    />
                </div>
            </div>
        </div>
        <create-tpl-panel v-model="isShowCreatePanel" />
        <v-dialog
            v-model="openAgencyShow"
            class="agencyPrompt"
            kind="alert"
        >
            <div class="dialogTxt">
                请联系经销商 {{ agencyName }}({{ agencyTelephone }}) 续费
            </div>
        </v-dialog>
        <v-dialog
            v-model="openUpdateShow"
            class="UpdatePrompt"
            title="更新权限角色后，所有已到期套餐的权限角色将会被删除"
            kind="confirm"
            status="warning"
            @confirm="openUpdateClick"
        >
            <div class="updateTxt">
                <p>如果角色仅含有已到期套餐，则该角色会被删除</p>
                <p>如果角色含有已到期和未到期的套餐，则已到期套餐的权限会被删除</p>
                <p>续费后，已被删除的权限角色不会恢复，需要再次配置</p>
            </div>
            <span slot="confirm-text">更新权限角色</span>
        </v-dialog>
    </div>
</template>

<script>
import createTplPanel from '../components/create-tpl-panel';
import roleItem from '../components/role-item';

const OPTIONS = [
    {
        label: '仅本人拥有的权限',
        desc:
            '有「权限角色」权限的员工，仅可将自己拥有的权限赋予给自己和其他人<br>创建/编辑/删除角色、给员工赋予角色时，都会校验是否超出了自己的权限范围',
        tip: '为了您的企业安全，建议使用此设置项',
        value: 'self',
    },
    {
        label: '企业所有权限',
        desc: '有「权限角色」权限的员工，可以将任意权限赋予给任何人',
        tip: '',
        value: 'all',
    },
];

export default {
    components: {
        roleItem,
        createTplPanel,
    },
    data() {
        return {
            loading: false,
            isShowCreatePanel: false,
            roleList: [],
            index: 1,
            total: 0,
            count: 5,
            countOptions: [5, 10, 15],
            listKey: 'lk',
            tipBarClosed: false,
            userinfo: {},
            changePowerMenuVisiable: false,
            powerMode: 'all',
            powerModelBak: 'all',
            options: OPTIONS,
            isShow: this.isShow,
            expiredCombosList: this.expiredCombosList,
            jumpUrl: this.jumpUrl,
            agencyInfo: this.agencyInfo,
            agencyName: this.agencyName,
            agencyTelephone: this.agencyTelephone,
            openAgencyShow: false,
            openUpdateShow: false,
        };
    },
    computed: {
        hasCloseTipFlagExist() {
            return localStorage.getItem(`show_tip_flag_${this.userinfo.kfuin}`);
        },
        isAdmin() {
            return this.userinfo.isAdmin;
        },
        isSuperAdmin() {
            const { isAdmin } = this.userinfo;
            return isAdmin;
        },
    },

    // beforeRouteEnter(to, from, next) {
    //     next(vm => {
    //         if (to.meta.refresh) {
    //             vm.refreshList();
    //         }
    //     });
    // },

    created() {
        this.initData();
        this.roleInit();
        console.log('querty', this.$router.query);

        this.fetchPermissionMngScope();

        // 从组织架构创建角色调整过来的链接是 /jumpcreate, meta.showCreate为true
        if (this.$route.meta.showCreate) {
            this.isShowCreatePanel = true;
        }
    },

    activated() {
        // 如果是从编辑页返回回来，则要重新刷新页面，获取最新权限信息
        if (sessionStorage.getItem('over_power_reload_flag')) {
            sessionStorage.removeItem('over_power_reload_flag');
            window.location.reload();
        }

        if (this.$route.meta.refresh) {
            this.refreshList();
        }
    },

    methods: {
        handleCloseNotice() {
            this.tipBarClosed = true;
            localStorage.setItem(`show_tip_flag_${this.userinfo.kfuin}`, 1);
        },
        handleChangePowerMode() {
            this.changePowerMenuVisiable = true;
        },
        handleConfirm() {
            this.changePowerMenuVisiable = false;
            this.updatePermissionMngScope();
        },
        handleCancel() {
            this.powerMode = this.powerModelBak;
            this.changePowerMenuVisiable = false;
        },
        initData() {
            this.fetchRoleList();
            this.userinfo = window.QD_ADMIN_COMMON?.data?.profile || {};
        },

        changePage(index, count) {
            this.index = index;
            this.count = count;
            this.fetchRoleList();
        },

        updatePermissionMngScope() {
            // 没有更改权限，直接返回
            if (this.powerModelBak === this.powerMode) {
                return;
            }
            this.$ajax
                .post('/mng/role/updatePermissionMngScope', {
                    scope: this.powerMode,
                })
                .then(
                    (res) => {
                        const { code, message } = res || {};
                        if (parseInt(code, 10) !== 0) {
                            // 更新权限失败，重置权限
                            this.powerMode = this.powerModelBak;
                            this.$message.error(message || '设置权限失败，请稍后重试');
                            return;
                        }
                        this.$message.success('权限范围变更成功');
                        this.fetchPermissionMngScope();
                    },
                    (error) => {
                        this.$message.error((error && error.message) || '设置权限失败，请稍后重试');
                    },
                );
        },

        fetchPermissionMngScope() {
            this.$ajax.read('/mng/role/permissionMngScope').then(
                (res) => {
                    const { code, scope, message } = res || {};

                    if (parseInt(code, 10) === 0) {
                        this.powerMode = scope;
                        this.powerModelBak = scope;
                    } else {
                        this.$message.error(message || '获取权限失败，请稍后重试');
                    }
                },
                (error) => {
                    this.$message.error((error && error.message) || '获取权限失败，请稍后重试');
                },
            );
        },
        customFn(res) {
            this.loading = false;
            this.$message.error(res?.message || '加载失败，请稍后重试');
        },
        fetchRoleList() {
            this.loading = true;
            this.$ajax
                .read('/mng/role/roleList', {
                    page: this.index,
                    pagesize: this.count,
                }, { customFn: this.customFn })
                .then(
                    (res) => {
                        const { code, list, totalNum, message } = res || {};

                        if (parseInt(code, 10) === 0) {
                            this.roleList = list || [];
                            this.total = parseInt(totalNum, 10) || [];
                        } else {
                            this.$message.error(message || '加载失败，请稍后重试');
                        }

                        this.loading = false;

                        this.listKey = `lk${Date.now()}`;
                    },
                    (error) => {
                        this.$message.error((error && error.message) || '加载失败，请稍后重试');
                        this.loading = false;
                    },
                );
        },

        refreshList() {
            this.index = 1;
            this.fetchRoleList();
        },

        createRole() {
            this.isShowCreatePanel = true;
        },
        roleInit() {
            this.$ajax.read('/mng/account/index/CombosExpiredTips').then((res) => {
                if (res.code === 0) {
                    const roleData = res.data || {};
                    this.isShow = roleData.isShow;
                    this.expiredCombosList = roleData.expiredCombos;
                    this.jumpUrl = roleData.jumpUrl;
                    this.agencyInfo = roleData.agency;
                    this.agencyName = roleData.agency.name;
                    this.agencyTelephone = roleData.agency.telephone;
                }
            });
        },
        roleRenew() {
            this.openAgencyShow = true;
            // const { name, telephone } = this.agencyInfo;
            // const dialog = this.$alert({
            //     confirmText: '知道了',
            //     status: 'primary',
            //     render() {
            //         return (
            //             <div
            //                 style={{
            //                     fontSize: '24px',
            //                     lineHeight: '34px',
            //                     color: '#1E2330',
            //                     width: '380px',
            //                     textAlign: 'center'
            //                 }}
            //             >
            //                 请联系经销商 {name}({telephone}) 续费
            //             </div>
            //         );
            //     },
            //     confirm: e => {
            //         e.preventDefault();
            //         dialog.$remove();
            //     }
            // });
        },

        roleUpdate() {
            this.openUpdateShow = true;
            // const dialog = this.$confirm({
            //     title: '更新权限角色后，所有已到期套餐的权限角色将会被删除',
            //     status: 'warning',
            //     confirmText: '更新权限角色',
            //     render() {
            //         return (
            //             <div style={{ width: '424px', marginTop: '32px', textAlign: 'center' }}>
            //                 <p>如果角色仅含有已到期套餐，则该角色会被删除</p>
            //                 <p>如果角色含有已到期和未到期的套餐，则已到期套餐的权限会被删除</p>
            //                 <p>续费后，已被删除的权限角色不会恢复，需要再次配置</p>
            //             </div>
            //         );
            //     },
            //     confirm: e => {
            //         e.preventDefault();
            //         dialog.$remove();
            //         this.$ajax.get('/mng/role/UpdateExpiredRoles').then(() => {
            //             setTimeout(() => {
            //                 this.initData();
            //                 this.fetchRoleList();
            //                 this.roleInit();
            //             }, 10);
            //         });
            //     }
            // });
        },
        openUpdateClick() {
            this.openUpdateShow = false;
            this.$ajax.get('/mng/role/UpdateExpiredRoles').then(() => {
                setTimeout(() => {
                    this.initData();
                    this.fetchRoleList();
                    this.roleInit();
                }, 10);
            });
        },
    },
};
</script>
<style lang="less" scoped>
.status-bar-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-right: -24px;
    line-height: 20px;
    .content-text {
        font-size: 14px;
        color: #1e2330;
    }
    .close-notice-btn {
        margin-right: 10px;
        width: 60px;
        cursor: pointer;
        font-size: 14px;
        color: #0067ed;
    }
}
.role-list-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    .power-manage {
        display: flex;
        align-items: center;
        font-size: 14px;
        line-height: 20px;
        color: #66686c;
        .change-power {
            position: relative;
            z-index: 11;
            .panel-wrapper {
                position: absolute;
                right: -2px;
                top: 30px;
                width: 483px;
                border: 1px solid #dadee7;
                box-shadow: 0 5px 30px 0 rgba(30, 36, 49, 0.15);
                border-radius: 3px;
                background-color: #fff;
                padding: 16px;
                .panel-body {
                    .radio-label {
                        font-size: 14px;
                        line-height: 20px;
                    }
                    .panel-body-item {
                        font-size: 12px;
                        margin-bottom: 16px;
                        color: #1e2330;
                        .desc {
                            margin-top: 6px;
                            color: #a8abb3;
                            margin-left: 30px;
                        }
                        .tip {
                            color: orange;
                            margin-left: 30px;
                        }
                    }
                }
                .panel-foot {
                    text-align: right;
                }
            }
            .change-power-btn {
                color: #0067ed;
                padding: 4px;
                margin-left: 8px;
                cursor: pointer;
            }
        }
    }
}
.role-list-pagination {
    margin-top: 0px;
}
</style>
